// @ts-nocheck
import { useEffect, useState } from 'react';
import { CenteredModal } from '../../../../components/CenteredModal';
import { SECTION_318_RELATIONSHIPS } from '../shared/voteRoomConstants';

/**
 * Exclude-as-§318-constructively-owned modal. Replaces the previous `document.getElementById` reads
 * with controlled `<select>` state so the modal is safe to mount multiple times and resets cleanly
 * between shareholders.
 */
export const Section318ExclusionModal = ({ shareholder, dqis, onCancel, onConfirm }) => {
  const [dqi, setDqi] = useState('');
  const [rel, setRel] = useState('');

  useEffect(() => {
    if (shareholder) {
      setDqi('');
      setRel('');
    }
  }, [shareholder?.id]);

  if (!shareholder) return null;
  const hasDqis = dqis.length > 0;

  return (
    <CenteredModal open onClose={onCancel} maxWidthClass="max-w-sm">
      <div className="px-5 py-4 border-b border-gray-100">
        <h3 className="text-xs font-semibold text-gray-900">Section 318 Constructive Ownership</h3>
        <p className="text-xs text-gray-400 mt-0.5">
          Exclude <strong>{shareholder.name}</strong> as attributable to a DQI
        </p>
      </div>
      <div className="p-5 space-y-3">
        {!hasDqis ? (
          <p className="text-xs leading-snug text-amber-800">
            No DQIs over the 280G threshold in this analysis. Add threshold exceeders in the workflow or run 280G
            results before using Section 318 constructive ownership exclusions.
          </p>
        ) : (
          <>
            <select
              value={dqi}
              onChange={(e) => setDqi(e.target.value)}
              aria-label="Attributed DQI"
              className="w-full h-8 px-3 text-xs border border-gray-200 rounded-md outline-none focus:border-emerald-400"
            >
              <option value="" disabled>
                Select DQI...
              </option>
              {dqis.map((d) => (
                <option key={d.name} value={d.name}>
                  {d.name} ({d.title})
                </option>
              ))}
            </select>
            <select
              value={rel}
              onChange={(e) => setRel(e.target.value)}
              aria-label="Constructive ownership relationship"
              className="w-full h-8 px-3 text-xs border border-gray-200 rounded-md outline-none focus:border-emerald-400"
            >
              <option value="" disabled>
                Select relationship...
              </option>
              {SECTION_318_RELATIONSHIPS.map((r) => (
                <option key={r.value} value={r.value}>
                  {r.label}
                </option>
              ))}
            </select>
          </>
        )}
      </div>
      <div className="px-5 py-3.5 border-t border-gray-100 bg-gray-50/50 rounded-b-xl flex justify-end space-x-2">
        <button type="button" onClick={onCancel} className="px-3 py-1.5 text-xs font-medium text-gray-500">
          Cancel
        </button>
        <button
          type="button"
          onClick={() => {
            if (hasDqis && dqi && rel) onConfirm(shareholder.id, dqi, rel);
          }}
          disabled={!hasDqis || !dqi || !rel}
          className="px-3 py-1.5 rounded-md text-xs font-semibold bg-amber-500 text-white hover:bg-amber-600 transition-colors disabled:cursor-not-allowed disabled:opacity-40"
        >
          Exclude Shareholder
        </button>
      </div>
    </CenteredModal>
  );
};
